<template>
	<form name="contact-form" :style="cssProps">

        <div class="form-group columns">
            <div class="column one-third">
                <!-- Name -->
                <div class="form-group is-small" :class="{'has-error' : $v.name.$error}">
                    <label for="name" :class="['label']">Your Name (required)</label>
                    <input name="name" type="text" :class="['input', inputColor, {'is-outline' : isInputOutlined}]" v-model="$v.name.$model">
                    <FormError :error="$v.name.$error" :message="nameError" />
                </div>
                <!-- Phone -->
                <div class="form-group is-small">
                    <label for="phone" :class="['label']">Phone Number</label>
                    <input name="phone" type="text" :class="['input', inputColor, {'is-outline' : isInputOutlined}]" v-model="phone">
                    <FormError/>
                </div>
                <!-- Email -->
                <div class="form-group is-small" :class="{'has-error' : $v.email.$error}">
                    <label for="email" :class="['label']">Email (required)</label>
                    <input name="email" type="text" :class="['input', inputColor, {'is-outline' : isInputOutlined}]" v-model="$v.email.$model">
                    <FormError :error="$v.email.$error" :message="emailError" />
                </div>
            </div>

            <div class="column two-thirds">
                <!-- Message -->
                <div class="form-group" :class="{'has-error' : $v.message.$error}">
                    <label for="message" class="label">Message (required)</label>
                    <textarea name="message" id="message" :class="['input no-resize', inputColor, {'is-outline' : isInputOutlined}]" v-model="$v.message.$model"></textarea>
                    <FormError :error="$v.message.$error" :message="messageError" />
                </div>
            </div>
        </div>

        <div class="type--centred">
            <button
                type="submit"
                :class="['type--serif', 'type--m', 'button', submitColor, {'is-outline' : isSubmitOutlined}]"
                @click.prevent="handleSubmit"
                @mouseover="$v.$touch()"
                @mouseout="$v.$reset()"
            >Send Message</button>
        </div>

		<!-- Confirmation modal -->
        <FlytModal
            title="Thank you for getting in touch"
            submit="Close"
            :visible="formSubmitted"
            @submit="formSubmitted = false"
            @close="formSubmitted = false"
        >
            <p class="type--serif">We aim to respond to your message within 24 hours. If you already have an imminent flight please login and go to your upcoming booking in on your profile, where you will find a contact number for the operator handling your helicopter flight.</p>
        </FlytModal>

    </form>
</template>

<script>
import FormError from "@/components/formfields/FormError"
import FlytModal from '@/components/FlytModal'
import { required, email, minLength } from "vuelidate/lib/validators"
import ApiService from '@/services/apiService'

export default {
    name: "ContactForm",

    data() {
        return {
            name: '',
            email: '',
            phone: '',
            message: '',
            formSubmitted: false
        }
    },

	props: {
		inputColor: {
			type: String,
			default: ''
		},
		inputOutlined: {
			type: String,
			default: '0'
		},
		labelColor: {
			type: String,
			default: '#848484'
		},
		submitColor: {
			type: String,
			default: 'is-primary'
		},
		submitOutlined: {
			type: String,
			default: '0'
		},
	},

    components: { FormError, FlytModal },

	validations: {
		name: {
            required,
            minLength: minLength(4),
        },
		email: {
            required,
            email
        },
		message: {
            required,
            minLength: minLength(12)
        },
    },

    computed: {
		nameError() {
			let errorMessage = "Invalid input"
			if (!this.$v.email.minLength) errorMessage = "Must be at least 4 characters long"
			if (!this.$v.email.required) errorMessage = "Please enter your name"
			return errorMessage
		},

        emailError() {
			let errorMessage = "Invalid input"
			if (!this.$v.email.email) errorMessage = "Please enter a valid email address"
			if (!this.$v.email.required) errorMessage = "Please enter your email address"
			return errorMessage
		},

        messageError() {
			let errorMessage = "Invalid input"
			if (!this.$v.email.minLength) errorMessage = "Message must be at least 12 characters long"
			if (!this.$v.email.required) errorMessage = "A message is required"
			return errorMessage
        },

		isInputOutlined() {
			return parseInt(this.inputOutlined)
		},

		isSubmitOutlined() {
			return parseInt(this.submitOutlined)
		},

        payload() {
            let payload = {
                name: this.name,
                email: this.email,
                phone: this.phone,
                message: this.message,
            }
            return payload
		},

		cssProps() {
			return {
				'--label-color': this.labelColor
			}
		}
    },

    methods: {
        clearForm() {
            this.name = ''
            this.email = ''
            this.phone = ''
            this.message = ''
        },

		handleSubmit() {
            this.$v.$touch()
			if (this.$v.$invalid) return

			ApiService.post('/contacts', this.payload)
				.then(() => {
					this.formSubmitted = true
					this.clearForm()
				})
				.catch((error) => console.log("error :>> ", error))
		},
    }
}
</script>

<style scoped>
.column {
    margin-bottom: 1rem;
}

.label {
	color: var(--label-color, #848484);
}

#message {
    height: 14.5rem;
}
</style>
